// The output ratios a format can declare.
//
// Mirrors ALLOWED_OUTPUT_ASPECTS in the collector's generationPrompt.js — the
// server validates against its own copy and 400s an unsupported value, so this
// list only decides what the picker OFFERS.

export const STATIC_ASPECTS = ['9:16', '4:5', '1:1'] as const;

export const ASPECT_LABEL: Record<string, string> = {
  '9:16': '9:16 — vertical (Stories, Reels)',
  '4:5': '4:5 — portrait (feed)',
  '1:1': '1:1 — square (feed)',
};

/**
 * Which placement an aspect serves, matching how the Ad Launcher reads Marsha's
 * table: 4:5 and 1:1 are the feed asset, 9:16 is the story asset.
 *
 * A creative needs one of each to be launchable, which is what the "add size"
 * action exists to produce.
 */
export const ASPECT_PLACEMENT: Record<string, 'feed' | 'story'> = {
  '9:16': 'story',
  '4:5': 'feed',
  '1:1': 'feed',
};

/** The aspect token a published filename carries: '4:5' → '4X5'. */
export function aspectToken(aspect?: string | null): string {
  return String(aspect || '').trim().replace(':', 'X').toUpperCase();
}

/** True when this set of aspects covers a placement — 1:1 and 4:5 both count as feed. */
export function hasPlacement(aspects: Iterable<string>, placement: 'feed' | 'story'): boolean {
  for (const aspect of aspects) {
    if (ASPECT_PLACEMENT[aspect] === placement) return true;
  }
  return false;
}

/**
 * The options a select should show for a stored value.
 *
 * An unknown stored value stays SELECTABLE rather than rendering blank. A select
 * whose current value is not among its options shows empty, and the next save
 * then silently writes that emptiness back — which is exactly how a keyword set
 * to a date preset this build did not know about ended up searching all time.
 */
export function aspectOptions(current?: string | null): string[] {
  const options = [...STATIC_ASPECTS] as string[];
  const value = typeof current === 'string' ? current.trim() : '';
  if (value && !options.includes(value)) options.push(value);
  return options;
}

/** A label for an aspect, falling back to the raw value for an unknown one. */
export function aspectLabel(aspect?: string | null): string {
  const value = typeof aspect === 'string' ? aspect.trim() : '';
  if (!value) return '—';
  return ASPECT_LABEL[value] || value;
}
